<mat-form-field class="example-full-width">
  <input #inputName [value]="dataText" matInput type="text" placeholder="{{placeholder}}" aria-label="Number" [matAutocomplete]="auto" (input)="termSearch($event.target.value)" (focusout)="onBlurMethod($event.target.value)">
  <mat-autocomplete class="autocomplete" #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setAttribute($event, $event.option.value)" >
      <mat-option *ngIf="addAll" [value]="{_id: '-1', text: 'Select All'}" title="Select All">Select All
      </mat-option>
      <mat-option *ngFor="let option of filteredData | async" [value]="option" title="{{option.text}}">{{option.text}} <i *ngIf="canDelete" class="material-icons deleteItem" (click)="deleteItem($event, option)">{{'Close' | translate}}</i>
      </mat-option>
    </mat-autocomplete>
</mat-form-field>
